/**
 * ConfigurationManager.
 * Manages configuration across whole platform. Accessible from any class. Behaves as singleton
 *
 * @copyright Realeyes OU. All rights reserved.
 */

const defaultEmptyConfig = { aws: { kinesis: {} } };

export default class ConfigurationManager {
    /**
     * Creates ConfigurationManager instance.
     * @param {object} config configuration
     */
    constructor(config = {}) {
        // if (!instance) {
        //     instance = this;
        // }

        this.time = new Date();
        this.config = config || defaultEmptyConfig;
    }

    /**
     * Initialize ConfigurationManager instance with external parameters
     * @param{Object.<{
     *   isDebugMode: boolean,
     *   aws: Object.<{
     *     kinesis: Object.<{
     *       defaultRegion: string,
     *       eventStreamName: string,
     *       logStreamName: string
     *     }>,
     *     credentialsServiceUrl: string
     *   }>}>} config is on fly requested Realeyes platform configuration
     * @return{void}
     */
    init(config) {
        this.config = config;
    }

    /**
     * Get isDebugMode configuration setting
     * @returns {Boolean}
     */
    isDebugMode() {
        return !!this.config.isDebugMode;
    }
}

// todo: add default configuration
